import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend
} from "recharts";

export default function ReactiveActiveEnergyPie({ deviceId, API_BASE }) {
    const { t } = useTranslation();
    const [importVal, setImportVal] = useState(0);
    const [exportVal, setExportVal] = useState(0);

    useEffect(() => {
        async function load() {
            const res = await fetch(`${API_BASE}/reactive/energy/active?deviceId=${deviceId}`);
            const json = await res.json();

            // Toplam Import + Export değerleri
            setImportVal(Math.trunc((Number(json.EL_SUM_IMPORT) || 0) * 1000) / 1000);
            setExportVal(Math.trunc((Number(json.EL_SUM_EXPORT) || 0) * 1000) / 1000);

        }

        load();
    }, [deviceId, API_BASE]);

    const realImport = importVal > 0 ? importVal : 0.001;
    const realExport = exportVal > 0 ? exportVal : 0.001;

    const data = [
        { name: t('energies.importActive'), value: realImport },
        { name: t('energies.exportActive'), value: realExport }
    ];

    const COLORS = ["#10B981", "#F59E0B"];

    return (
        <div className="bg-white p-5 border rounded-xl shadow-sm">
            <h3 className="text-sm font-semibold text-slate-700 mb-3">
                {t('dashboard.activeEnergyDist')}
            </h3>

            <div className="flex items-center justify-center h-72">
                <PieChart width={300} height={300}>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="60%"
                        outerRadius={110}
                        dataKey="value"
                    >
                        {data.map((_, i) => (
                            <Cell key={i} fill={COLORS[i]} />
                        ))}
                    </Pie>

                    <Tooltip formatter={(v) => `${Number(v).toFixed(3)} kWh`} />

                    <Legend
                        layout="horizontal"
                        verticalAlign="bottom"
                        wrapperStyle={{
                            transform: "translateY(15px)"
                        }}
                    />
                </PieChart>
            </div>
        </div>
    );
}
